import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { formatVersionDate } from '../venue-sheet.js'
import type { SaveStatus } from './use-save-tracker.js'
import styles from './stage-setup-editor.module.css'

export interface SaveStatusLineProps {
  status: SaveStatus
  updatedAt?: string
  onRetry(): void
}

/** "Saving…", then "Last updated {date}" only once the write is confirmed; a failure offers Retry. */
export const SaveStatusLine: FC<SaveStatusLineProps> = props => {
  const { status, updatedAt, onRetry } = props
  const date = updatedAt ? formatVersionDate(updatedAt) : undefined
  return (
    <div className={styles.status}>
      <p role="status" className={status === 'error' ? styles.statusError : styles.statusText}>
        {status === 'saving' ? 'Saving…' : null}
        {status === 'error' ? "Couldn't save your setup." : null}
        {status === 'idle' && date ? `Last updated ${date}` : null}
      </p>
      {status === 'error' ? (
        <Button size="small" variant="outlined" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  )
}

export default SaveStatusLine
